.container {
  display: grid;
  margin-top: 28px;
  width: 100%;
  background-color: #F3F3F3;

  .mainInfo{
    display: grid;
    align-items: start;
    margin: 35px 30px 30px 40px;
  }

  .virtualDeskInfo{
    margin-top: 20px;
    margin-inline: 95px;
    display: grid;
    align-items: center;
    justify-items: center;
    text-align: center;
    color: #636363;
  }

  .buttonContainer {
    display: grid;
    justify-items: center;
    margin: 35px;
  }
}
